import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GridCell } from '../../../models/sections-model';

@Component({
  selector: 'kw-blog-header-renderer',
  templateUrl: './blog-header-renderer.component.html',
  styleUrls: ['./blog-header-renderer.component.scss']
})
export class BlogHeaderRendererComponent implements OnChanges {
  
  @Input() blogHeader:GridCell;

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["blogHeader"]){
      this.blogHeader.contentElements.forEach(el => {
        console.log(el);
      })
    }
  }

  /* if(this.blogHeader != undefined){
    console.log("Blog header found")
    this.blogHeader.contentElements.forEach(contentElement => {
      switch (contentElement.name) {
        case "title":
          this.titleContent = contentElement;
          this.addDefaultClasses(contentElement);
          break;
        case "byline":
          this.authorContent = contentElement;
          this.addDefaultClasses(contentElement);
          break;
        case "date":
          this.dateContent = contentElement;
          this.addDefaultClasses(contentElement);
          break;
      
        default:
          break;
      }
    })      
  }else{
    console.log("Blog NOT header found")
    if(this.data.title != undefined){
      console.log(this.data.title);
      this.titleContent = this.data.title;
    }
  } */
}
